import apiClient from './client';
import { CreateStyleGuideSchema, UpdateStyleGuideSchema } from 'shared-schemas';

export const styleGuidesApi = {
  /**
   * List all style guides with pagination.
   */
  list: async (params = {}) => {
    const response = await apiClient.get('/api/style-guides', { params });
    return response.data;
  },

  /**
   * Get all core style guides (voice, emojis, phrases, formatting).
   */
  getCore: async () => {
    const response = await apiClient.get('/api/style-guides/core');
    return response.data;
  },

  /**
   * Get a single style guide by ID.
   */
  get: async (id) => {
    const response = await apiClient.get(`/api/style-guides/${id}`);
    return response.data;
  },

  /**
   * Create a new style guide.
   */
  create: async (guideData) => {
    const validated = CreateStyleGuideSchema.parse(guideData);
    const response = await apiClient.post('/api/style-guides', validated);
    return response.data;
  },

  /**
   * Update an existing style guide.
   */
  update: async (id, guideData) => {
    const validated = UpdateStyleGuideSchema.parse(guideData);
    const response = await apiClient.patch(`/api/style-guides/${id}`, validated);
    return response.data;
  },

  /**
   * Delete a style guide.
   */
  delete: async (id) => {
    await apiClient.delete(`/api/style-guides/${id}`);
  },
};
